import { useMemo } from 'react';

import type { CatalogItem } from '@/entities/catalog-item';

import { createCatalogFuse } from '../lib/catalogFuse';

export function useFuzzySearchedCatalogData(
  items: CatalogItem[],
  search: string | null
): CatalogItem[] {
  const fuse = useMemo(() => createCatalogFuse(items), [items]);

  return useMemo(() => {
    const query = search?.trim();
    if (!query) return items;
    return fuse.search(query).map(result => result.item);
  }, [fuse, items, search]);
}
